(function($){

  function getAdHolders() {
    return $('.advertisement-holder').map(function(){
      return $(this);
    });
  }

  var intvl = 1E3;
  var defaultHeight = 50;
  var adHolders = getAdHolders();

  setInterval(function() {
    adHolders.each(function(){
      var adHeight = this.height();
      var thresholdHeight = this.data('label-height') || defaultHeight;
      this.toggleClass('ad-visible', adHeight >= thresholdHeight);
      return;
    });
  }, intvl);

  return window.MW && window.MW.events.subscribe('infinite_scroll', function(){
    adHolders = getAdHolders();
  });

})(window.jQuery);

// show/hide label
(function() {
  setInterval(function() {
    var hiddenAds = document.querySelectorAll('.advertisement, .entry-paragraph-ad');
    for (var i = 0; i < hiddenAds.length; i++) {
      var ad = hiddenAds[i];
      var $ad = $(ad);
      var toggle = false;
      var adChildren = ad.getElementsByTagName('*');
      for (var j = 0; j < adChildren.length; j++) {
        var a = null;
        var $adChild = $(adChildren[j]);
        if ($adChild.prop('tagName').toLowerCase() !== "script" &&
            !$adChild.hasClass('advertisement__label') &&
            $adChild.is(":visible") &&
            $adChild.height() > 20 &&
            $adChild.css('display') !== "none" &&
            !$adChild.closest('[style*=display: none]').length &&
            !((a = $adChild.closest('[style*=overflow: hidden]')).length && a.height() <= 20)) {
          toggle = true;
          break;
        }
      }

      $ad.data("treated", toggle).toggleClass("treated", toggle);
    }
  }, 500);
}());
